export default "__VITE_ASSET__Dg91a__j__"